import { SubItemMenu } from "./SubItemMenu";

interface SubItemMenuWrapperProps {
  items: Array<{
    title: string;
    to: string;
    hasDivider?: boolean;
    fullTitle?: string;
    id: number;
  }>;
  open: boolean;
}

export function SubItemMenuWrapper({ items, open }: SubItemMenuWrapperProps) {
  if (!items?.length) return null;

  return (
    <div
      className={`
        flex flex-col gap-1 ml-4  overflow-auto
        transition-all duration-300 ease-out
  ${open ? "max-h-screen opacity-100 mt-1 mb-1" : "max-h-0 opacity-0"}    `}
    >
      {items.map((item, index) => (
        <SubItemMenu key={`${item.id}-${index}`} {...item} />
      ))}
    </div>
  );
}
